import React from 'react';
 
export default function LodOutSay(props){
    return (
 <div className=' mt-20 mb-20 w-30  '>
<h2 class={props.colorText === undefined ? "text-gray-800 md:text-5xl text-2xl font-extralight text-center" : props.colorText}>
{props.smallText}
   </h2>
<h2 class= {props.colorText2 === undefined ? "text-black md:text-2xl  sm:text-9xl lg:text-9xl xl:text-9xl font-bold   text-6xl   mb-12  text-center": props.colorText2 } >
   {props.biggerText}
   </h2>
</div>
)
}